import { useEffect, useState } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    const controller = new AbortController();
    window.addEventListener('resize', handleResize, { signal: controller.signal });
    window.addEventListener('orientationchange', handleResize, { signal: controller.signal });
    return () => controller.abort();
  }, []);

  return windowDimensions;
}
